export default __webpack_public_path__ + "static/media/workshop.12d34d1b.jpg";